
"use client";

import Link from "next/link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";

const navLinks = [
  { href: "/", label: "Startseite" },
  { href: "/#leistungen", label: "Fokus" },
  { href: "/blog", label: "Blog" },
  { href: "/kontakt", label: "Kontakt" },
  { href: "/impressum", label: "Impressum" },
];

export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const pathname = usePathname();

  const isActive = (href: string) => {
    if (href === "/blog") return pathname.startsWith("/blog");
    if (href === "/kontakt") return pathname === "/kontakt";
    if (href === "/") return pathname === "/";
    return pathname === href;
  };

  return (
    <header className="sticky top-0 z-50 bg-background/85 backdrop-blur-md border-b border-border">
      <div className="flex items-center justify-between max-w-[1180px] mx-auto px-4 sm:px-8 h-[72px]">
        <Link href="/" className="flex items-center gap-2.5 font-display font-semibold text-[1.05rem] tracking-tight">
          <span
            aria-hidden="true"
            className="w-[26px] h-[26px] shrink-0"
            style={{
              backgroundColor: "var(--signal)",
              maskImage: "url('/img/logo-transparent.png')",
              WebkitMaskImage: "url('/img/logo-transparent.png')",
              maskSize: "contain",
              WebkitMaskSize: "contain",
              maskRepeat: "no-repeat",
              WebkitMaskRepeat: "no-repeat",
              maskPosition: "center",
              WebkitMaskPosition: "center",
              filter: "drop-shadow(0 0 5px rgba(242,169,59,0.45))",
            }}
          />
          Luehmann-IT
        </Link>

        <nav className="hidden min-[881px]:flex items-center gap-9">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className={cn(
                "relative text-[0.88rem] transition-colors",
                isActive(link.href)
                  ? "text-foreground"
                  : "text-[#8794A0] hover:text-foreground"
              )}
            >
              {link.label}
              {isActive(link.href) && (
                <span className="absolute left-0 right-0 -bottom-[26px] h-0.5 bg-[var(--signal)]" />
              )}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            href="/kontakt"
            className="hidden min-[881px]:inline-block font-mono text-[0.78rem] font-medium bg-[var(--signal)] text-[var(--ink)] px-4 py-[9px] rounded-[2px] tracking-[0.02em] hover:bg-[var(--signal-hover)] transition-colors"
          >
            Gespräch führen
          </Link>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="min-[881px]:hidden text-foreground hover:text-[var(--signal)] transition-colors"
            aria-label="Menü umschalten"
          >
            {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="min-[881px]:hidden border-t border-border bg-background/95 backdrop-blur-md">
          <div className="flex flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={cn(
                  "py-2.5 text-[0.95rem] transition-colors",
                  isActive(link.href) ? "text-[var(--signal)]" : "text-[#8794A0]"
                )}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              href="/kontakt"
              className="mt-2 font-mono text-[0.78rem] font-medium bg-[var(--signal)] text-[var(--ink)] px-4 py-2.5 rounded-[2px] text-center"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Gespräch führen
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
